export default __webpack_public_path__ + "947fc1b0cefa112a498b97b8101241f1.png";